// src/validated-env.browser.ts
import { createClientEnvironment, getClientEnv } from "./client-env.js";
var env = createClientEnvironment(getClientEnv());
export {
  env
};
